import actionTypes from '../constants';

// eslint-disable-next-line import/prefer-default-export
export function toggleSidebar() {
  return {
    type: actionTypes.SIDEBAR_VISIBILITY_TOGGLE,
  };
}
